var React = require('react');

function CrossInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.47 4.47l15.012 15.012m0-15.012L4.471 19.483","fill":"none","strokeLinecap":"square","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"}));
}

CrossInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = CrossInline;

CrossInline.default = CrossInline;
